import styled from 'styled-components';
import { LOW_WHITE } from '../../styles/Colors';
import { below } from '../../utils/Breakpoints';

export const AboutUsTitle = styled.h1`
  font-size: 64px;
  margin: 0;
  font-weight: bold;
  margin-bottom: 20px;
`;

export const CustomAboutUsCard = styled.div`
  height: 420px;
  width: 270px;
  background-color: ${LOW_WHITE};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 0.2s;
  margin-bottom: 10px;
  padding: 2%;
  &:hover {
    transition: 0.2s;
    box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.45);
  }
  ${below.med`
	 	height:300px; 
		 width:200px;
	  `}
`;

export const CardImage = styled.img`
  height: 65%;
  width: auto;
`;
export const CardTitle = styled.span`
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 10px;
  ${below.med`
	 	font-size:20px;
	  `}
`;
export const CardDescription = styled.span`
  font-size: 18px;
  font-weight: 300;
  width: 80%;
  ${below.med`
	 	font-size:14px;
	  `}
`;
export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 60%;
`;
